exports.calcMaxWidth = require('./calc-max-width').calcMaxWidth;
